import * as AgGrid from "ag-grid-community";
import * as datasource from "../../grid/datasource";
import * as gridUtils from "../../grid/utils";
import { ColumnsState } from "grid/columns_state";
import { GridController } from "grid/grid_controller";

import { ACTIONS_COL_DEF, DATE_FILTER_COL_DEF, DEFAULT_COL_DEF, TEXT_FILTER_COL_DEF } from "../../grid/columns";

interface AuditTrail {
  date: string;
  event: string;
  item_type: string;
  initiator: string;
}

export default class extends GridController<AuditTrail> {
  override buildGrid() {
    const { i18nJson, paginationPageSize } = this.gridTarget.dataset;

    const colDefs: AgGrid.ColDef[] = [
      { field: "created_at", colId: "created_at", ...DEFAULT_COL_DEF, ...DATE_FILTER_COL_DEF, sortable: true },
      { field: "event", colId: "event", ...DEFAULT_COL_DEF, ...TEXT_FILTER_COL_DEF, sortable: true },
      { field: "item_type", colId: "item_type", ...DEFAULT_COL_DEF, ...TEXT_FILTER_COL_DEF, sortable: true },
      { field: "initiator", colId: "initiator", ...DEFAULT_COL_DEF, ...TEXT_FILTER_COL_DEF, sortable: true },
      { ...ACTIONS_COL_DEF },
    ];

    const dataSource = new datasource.Datasource({ callbacks: {}, limit: paginationPageSize });

    const options: AgGrid.GridOptions<AuditTrail> = {
      ...gridUtils.DEFAULT_GRID_OPTIONS,
      defaultColDef: {
        ...(gridUtils.DEFAULT_GRID_OPTIONS.defaultColDef as AgGrid.ColDef<AuditTrail, any>),
      },
      columnDefs: gridUtils.buildColumnDefs(colDefs, { i18n: JSON.parse(i18nJson) }),
      datasource: dataSource,
      cacheBlockSize: parseInt(paginationPageSize),
      pagination: true,
      paginationPageSize: parseInt(paginationPageSize),
      onColumnResized(event: AgGrid.ColumnResizedEvent) {
        const columnsState = new ColumnsState(event.api, "user_audit_trails");
        columnsState.onResize(event);
      },
      context: {
        i18n: JSON.parse(i18nJson),
      },
    };

    const gridApi = AgGrid.createGrid(this.gridTarget, options);
    dataSource.gridApi = gridApi;

    return gridApi;
  }
}
